const STATUSES = {
  LOADING: "Loading",
  DONE: "Done",
  ERROR: "Error",
};

export default STATUSES;
